 
import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../../constants/enums";
import { StandadCard } from "../../../../../../components/Cards";
import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatchWrapper,
  useBreadcrumb,
} from "../../../../../../hooks";
import { useFormik } from "formik";

import { addCommAutoCSIOApplication, fetchCommAutoCSIOApplicationAsync } from "../../../../../../redux/commAutoPolicy/commAutoCsioApplication/commAutoCsioApplicationActions";
import { clearAutomobileCSIOApplicationState } from "../../../../../../redux/automobileCSIOApplication/automobileCSIOApplicationActions";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const CommAutomobileCsioApplicationForm: React.FC = () => {
  const { customerId, customerPolicyId, messageGUID } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    messageGUID?: string;
  };

  useBreadcrumb({
    title: "",
    items: [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/view-customers",
      title: "customers",
    },
    {
      to: "/customer-overview/" + customerId,
      title: "customer-overview",
    },
    {
      to:
        "/comm-automobile-policy/comm-automobile/" +
        customerId +
        "/" +
        customerPolicyId,
      title: "comm-auto",
    },
    {
      title: "application-form",
    },
  ],
  });


  const { csioData, loading } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.csioapplication
  );

  const [saveLoading, setSaveLoading] = React.useState(false);
  const [tab, setTab] = React.useState(0);

  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();


  React.useEffect(() => {
    return () => {
      dispatch(clearAutomobileCSIOApplicationState());
    };
  }, []);

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: csioData,
    validate: (values) => {
      const errors: any = {};
      // if(values.certificate_holder_phone)
      return errors;
    },
    onSubmit: (values) => {
      if (customerId && customerPolicyId) {
        setSaveLoading(true);
        dispatch(
          addCommAutoCSIOApplication(
            { ...values, customer_policy_id: customerPolicyId ?? null },
            (isSuccess) => {
              if (isSuccess) {
                // navigate(
                //   `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}?tab=0`
                // );
                setSaveLoading(false);
              }
            }
          )
        );
      }
    },
  });

  const onTabChange = (value: number) => {
    window.scrollTo(0, 400);
    setTab(value);
  };

  React.useEffect(() => {
    if (messageGUID) {
      dispatch(fetchCommAutoCSIOApplicationAsync(messageGUID));
    }
  }, [messageGUID]);

  React.useEffect(() => {
    setValues(csioData);
  }, [csioData]);

  React.useEffect(() => {
    return () => {
      dispatch(clearAutomobileCSIOApplicationState());
    };
  }, []);
  


  return (
     <PageContainer
            title={
              customerPolicyId
                ? "Create CSIO"
                : "Edit CSIO"
            }
            description="this is inner page ."
          >
    <PageLoader loading={loading === LoadState.InProgress}>
      <StandadCard sx={{ mt: 2 }} heading="Automobile Application Form">
        <Stepper sx={{ mb: 3, mt: 3 }} activeStep={tab} alternativeLabel>
          {[
            "Basic Details",
            "Described Automobiles",
            "Driver Information",
            "Previous Accidents and Insurance Claims",
            "History of Convictions",
            "Raiting Information",
            "Insurance Coverages Applied for",
            "Payment/Report of broker",
          ].map((label) => (
            <Step key={label}>
              <StepLabel>
                <Typography variant="h4" sx={{ fontSize: ".9rem" }}>
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <form onSubmit={handleSubmit}>
          {/* <TabPanel index={0} value={tab}>
            <CommAutoApplicationStep1
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              setValues={setValues}
              changeTab={onTabChange}
              customerPolicyId={customerPolicyId}
            />
          </TabPanel>

          

          <TabPanel index={7} value={tab}>
            <CommAutoApplicationStep8
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              setValues={setValues}
              saveLoading={saveLoading}
              changeTab={onTabChange}
            />
          </TabPanel> */}
        </form>
      </StandadCard>
    </PageLoader>
    </PageContainer>
  );
};
